<template>
    <q-page class=" q-pa-lg ">
        <q-dialog v-model="dialogDetMov" maximized>
            <q-card>
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">{{ $t('centroCostos.details.title') || 'Detalles' }}</div>
                    <q-space />
                    <q-btn icon="mdi-close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-table class="shadow-0 header-tabla" :columns="columnsDetPol" row-key="_id" :data="dataDetPol" :rows-per-page-options="[0]" :pagination.sync="pagination">
                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td auto-width key="acciones">
                                    <q-btn size="md" color="red-6" rounded flat dense icon="mdi-file-document"
                                        @click="VerPolizas(props.row)">
                                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                            content-style="font-size: 14px">{{ $t('centroCostos.auxiliar.viewVoucher') || 'Ver Póliza' }}</q-tooltip>
                                    </q-btn>
                                    <q-btn size="md" color="red-6" rounded flat dense icon="mdi-format-list-bulleted"
                                        @click="VerFacturas(props.row)">
                                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                            content-style="font-size: 14px">{{ $t('centroCostos.incomeStatement.viewInvoice') || 'Ver Facturas' }}</q-tooltip>
                                    </q-btn>
                                </q-td>
                                <q-td key="numCuenta" :props="props">{{ props.row.numCuenta }}</q-td>
                                <q-td key="descripcion" :props="props">{{ props.row.descripcion }}</q-td>
                                <q-td key="importe" :props="props">{{ formatCurrency(props.row.importe) }}</q-td>
                                <q-td key="importeComprobantes" :props="props">{{ formatCurrency(props.row.importeComprobantes) }}</q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </q-card-section>
            </q-card>
        </q-dialog>
        <q-dialog v-model="dialogFacturas" maximized>
            <q-card>
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">{{ $t('centroCostos.incomeStatement.viewInvoice') || 'Facturas' }}</div>
                    <q-space />
                    <q-btn icon="mdi-close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-table class="shadow-0 header-tabla" :columns="columnsFacturas" row-key="_id" :data="dataFacturas" :rows-per-page-options="[0]" :pagination.sync="pagination">
                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td auto-width key="acciones">
                                    <q-btn size="md" color="red-6" rounded flat dense icon="mdi-file-pdf-box"
                                        @click="VerFacturaPdf(props.row)">
                                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                            content-style="font-size: 14px">{{ $t('centroCostos.incomeStatement.viewInvoice') || 'Ver Factura' }}</q-tooltip>
                                    </q-btn>
                                </q-td>
                                <q-td key="serie" :props="props">{{ props.row.serie }}</q-td>
                                <q-td key="folio" :props="props">{{ props.row.folio }}</q-td>
                                <q-td key="fecha" :props="props">{{ props.row.fecha }}</q-td>
                                <q-td key="rfc" :props="props">{{ props.row.rfc }}</q-td>
                                <q-td key="nombre" :props="props">{{ props.row.nombre }}</q-td>
                                <q-td key="tipoComprobante" :props="props">{{ props.row.tipoComprobante }}</q-td>
                                <q-td key="subTotal" :props="props">{{ formatCurrency(props.row.subTotal) }}</q-td>
                                <q-td key="total" :props="props">{{ formatCurrency(props.row.total) }}</q-td>
                                <q-td key="formaPago" :props="props">{{ props.row.formaPago }}</q-td>
                                <q-td key="metodoPago" :props="props">{{ props.row.metodoPago }}</q-td>
                                <q-td key="folioFiscal" :props="props">{{ props.row.folioFiscal }}</q-td>
                                <q-td key="moneda" :props="props">{{ props.row.moneda }}</q-td>
                                <q-td key="usoCfdi" :props="props">{{ props.row.usoCfdi }}</q-td>
                                <q-td key="fechaPago" :props="props">{{ props.row.fechaPago }}</q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </q-card-section>
            </q-card>
        </q-dialog>
        <q-dialog v-model="dialogPolizas" maximized>
            <q-card>
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">{{ $t('home.polizas') || 'Pólizas' }}</div>
                    <q-space />
                    <q-btn icon="mdi-close" flat round dense v-close-popup />
                </q-card-section>
                <q-card-section>
                    <q-table class="shadow-0 header-tabla" :columns="columnsPolizas" row-key="_id" :data="dataPolizas" :rows-per-page-options="[0]" :pagination.sync="pagination">
                        <template v-slot:body="props">
                            <q-tr :props="props">
                                <q-td auto-width key="acciones">
                                    <q-btn size="md" color="red-6" rounded flat dense icon="mdi-file-pdf-box"
                                        @click="VerPolizaPdf(props.row)">
                                        <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                            content-style="font-size: 14px">{{ $t('centroCostos.auxiliar.viewVoucher') || 'Ver Póliza' }}</q-tooltip>
                                    </q-btn>
                                </q-td>
                                <q-td key="tipo" :props="props">{{ props.row.tipo }}</q-td>
                                <q-td key="numPoliza" :props="props">{{ props.row.numPoliza }}</q-td>
                                <q-td key="fecha" :props="props">{{ props.row.fecha }}</q-td>
                                <q-td key="importe" :props="props">{{ formatCurrency(props.row.importe) }}</q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogPDF" transition-show="scale" transition-hide="scale" maximized>
            <visor-pdf ref="miComponenteHijo" @CloseDialogPdf="CloseDialogPdf"></visor-pdf>
        </q-dialog>

        <div class="row q-col-gutter-sm q-mb-lg">
            <div class="col-12 col-md-5">
                <div class=" text-h5">{{ $t('centroCostos.balanceSheet.title') }}</div>
            </div>

            <div class="col-12 col-md-2">
                <q-input v-model="fehaIMasked" filled :label="$t('centroCostos.balanceSheet.initialDate')" class="q-mr-sm" name="event" outlined dense>
                    <template v-slot:before>
                        <q-icon name="event" color="primary" />
                    </template>
                    <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                        <q-date v-model="fechaI" @input="UltimoDiaMes">
                            <div class="row items-center justify-end">
                                <q-btn v-close-popup label="Ok" color="primary" flat />
                            </div>
                        </q-date>
                    </q-popup-proxy>
                </q-input>
            </div>

            <div class="col-12 col-md-2">
                <q-input v-model="fechaFMasked" filled :label="$t('centroCostos.balanceSheet.finalDate')" class="q-mr-sm" name="event" outlined dense>
                    <template v-slot:before>
                        <q-icon name="event" color="primary" />
                    </template>
                    <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                        <q-date v-model="fechaF">
                            <div class="row items-center justify-end">
                                <q-btn v-close-popup label="Ok" color="primary" flat />
                            </div>
                        </q-date>
                    </q-popup-proxy>
                    
                </q-input>
            </div>
            <div class="col-12 col-md-3">
                <q-select v-model="selectCc"  :options="itemsCc" dense filled :label="$t('centroCostos.balanceSheet.costCenter')" option-label="descripcion">
                    <template v-slot:after>
                        <q-btn flat round color="primary" icon="mdi-magnify" @click="GetEstadoDeSituacionFinanciera">
                            <q-tooltip>
                                {{ $t('centroCostos.balanceSheet.search') }}
                            </q-tooltip>
                        </q-btn>
                        <q-btn flat round color="primary" icon="mdi-microsoft-excel" @click="ExportExcel">
                            <q-tooltip>
                                {{ $t('centroCostos.balanceSheet.excel') }}
                            </q-tooltip>
                        </q-btn>
                        <q-btn flat round color="primary" icon="mdi-file-pdf-box" @click="ExportarPdf">
                            <q-tooltip>
                                {{ $t('centroCostos.balanceSheet.pdf') }}
                            </q-tooltip>
                        </q-btn>
                    </template>
                    </q-select>                        
            </div>
        </div>

        <div class="row q-col-gutter-sm">
            <div class="col-12 col-md-6">
                <q-list class="rounded-borders">
                    <q-expansion-item header-class="bg-grey-3" class="q-mb-md" switch-toggle-side expand-separator
                        icon="perm_identity" default-opened>
                        <template v-slot:header>
                            <q-item-section>
                                {{ $t('centroCostos.balanceSheet.currentAssets') }}
                            </q-item-section>
                            <q-item-section side>
                                {{ formatCurrency(sumActivoCirculante) }}
                            </q-item-section>
                        </template>
                        <q-table class="shadow-0" full-width row-key="name" :columns="columns"
                            :data="itemsActivoCirculante" hide-header hide-bottom :rows-per-page-options="[0]"
                            :pagination.sync="pagination">
                            <template v-slot:body="props">
                                <q-tr :props="props">
                                    <q-td auto-width key="acciones">
                                        <q-btn size="md" color="red-6" rounded flat dense icon="mdi-dots-vertical" v-if="props.row.detalles"
                                            @click="VerDetalles(props.row)">
                                            <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                                content-style="font-size: 14px">{{ $t('centroCostos.balanceSheet.details') }}</q-tooltip>
                                        </q-btn>
                                    </q-td>
                                    <q-td key="descripcion" :props="props">{{ props.row.descripcion }}</q-td>
                                    <q-td key="importe" :props="props">{{ formatCurrency(props.row.importe) }}</q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </q-expansion-item>
                    <q-expansion-item header-class="bg-grey-3" class="q-mb-md" switch-toggle-side expand-separator
                        icon="perm_identity" default-opened>
                        <template v-slot:header>
                            <q-item-section>
                                {{ $t('centroCostos.balanceSheet.fixedAssets') }}
                            </q-item-section>
                            <q-item-section side>
                                {{ formatCurrency(sumActivoFijo) }}
                            </q-item-section>
                        </template>
                        <q-table class="shadow-0" full-width row-key="name" :columns="columns" :data="itemsActivoFijo"
                            hide-header hide-bottom :rows-per-page-options="[0]" :pagination.sync="pagination">
                            <template v-slot:body="props">
                                <q-tr :props="props">
                                    <q-td auto-width key="acciones">
                                        <q-btn size="md" color="red-6" rounded flat dense icon="mdi-dots-vertical" v-if="props.row.detalles"
                                            @click="VerDetalles(props.row)">
                                            <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                                content-style="font-size: 14px">{{ $t('centroCostos.balanceSheet.details') }}</q-tooltip>
                                        </q-btn>
                                    </q-td>
                                    <q-td key="descripcion" :props="props">{{ props.row.descripcion }}</q-td>
                                    <q-td key="importe" :props="props">{{ formatCurrency(props.row.importe) }}</q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </q-expansion-item>
                    <q-expansion-item header-class="bg-grey-3" class="q-mb-md" switch-toggle-side expand-separator
                        icon="perm_identity" default-opened>
                        <template v-slot:header>
                            <q-item-section>
                                {{ $t('centroCostos.balanceSheet.deferredAssets') }}
                            </q-item-section>
                            <q-item-section side>
                                {{ formatCurrency(sumActivoDiferido) }}
                            </q-item-section>
                        </template>
                        <q-table class="shadow-0" full-width row-key="name" :columns="columns"
                            :data="itemsActivoDiferido" hide-header hide-bottom :rows-per-page-options="[0]"
                            :pagination.sync="pagination">
                            <template v-slot:body="props">
                                <q-tr :props="props">
                                    <q-td auto-width key="acciones">
                                        <q-btn size="md" color="red-6" rounded flat dense icon="mdi-dots-vertical" v-if="props.row.detalles"
                                            @click="VerDetalles(props.row)">
                                            <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                                content-style="font-size: 14px">{{ $t('centroCostos.balanceSheet.details') }}</q-tooltip>
                                        </q-btn>
                                    </q-td>
                                    <q-td key="descripcion" :props="props">{{ props.row.descripcion }}</q-td>
                                    <q-td key="importe" :props="props">{{ formatCurrency(props.row.importe) }}</q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </q-expansion-item>
                </q-list>
            </div>
            <div class="col-12 col-md-6">
                <q-list class="rounded-borders">
                    <q-expansion-item header-class="bg-grey-3" class="q-mb-md" switch-toggle-side expand-separator
                        icon="perm_identity" default-opened>
                        <template v-slot:header>
                            <q-item-section>
                                {{ $t('centroCostos.balanceSheet.currentLiabilities') }}
                            </q-item-section>
                            <q-item-section side>
                                {{ formatCurrency(sumPasivoCirculante) }}
                            </q-item-section>
                        </template>
                        <q-table class="shadow-0" full-width row-key="name" :columns="columns"
                            :data="itemsPasivoCirculante" hide-header hide-bottom :rows-per-page-options="[0]"
                            :pagination.sync="pagination">
                            <template v-slot:body="props">
                                <q-tr :props="props">
                                    <q-td auto-width key="acciones">
                                        <q-btn size="md" color="red-6" rounded flat dense icon="mdi-dots-vertical" v-if="props.row.detalles"
                                            @click="VerDetalles(props.row)">
                                            <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                                content-style="font-size: 14px">{{ $t('centroCostos.balanceSheet.details') }}</q-tooltip>
                                        </q-btn>
                                    </q-td>
                                    <q-td key="descripcion" :props="props">{{ props.row.descripcion }}</q-td>
                                    <q-td key="importe" :props="props">{{ formatCurrency(props.row.importe) }}</q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </q-expansion-item>
                    <q-expansion-item header-class="bg-grey-3" class="q-mb-md" switch-toggle-side expand-separator
                        icon="perm_identity" default-opened>
                        <template v-slot:header>
                            <q-item-section>
                                {{ $t('centroCostos.balanceSheet.longTermLiabilities') }}
                            </q-item-section>
                            <q-item-section side>
                                {{ formatCurrency(sumPasivoLargoPlazo) }}
                            </q-item-section>
                        </template>
                        <q-table class="shadow-0" full-width row-key="name" :columns="columns"
                            :data="itemsPasivoLargoPlazo" hide-header hide-bottom :rows-per-page-options="[0]"
                            :pagination.sync="pagination">
                            <template v-slot:body="props">
                                <q-tr :props="props">
                                    <q-td auto-width key="acciones">
                                        <q-btn size="md" color="red-6" rounded flat dense icon="mdi-dots-vertical" v-if="props.row.detalles"
                                            @click="VerDetalles(props.row)">
                                            <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                                content-style="font-size: 14px">{{ $t('centroCostos.balanceSheet.details') }}</q-tooltip>
                                        </q-btn>
                                    </q-td>
                                    <q-td key="descripcion" :props="props">{{ props.row.descripcion }}</q-td>
                                    <q-td key="importe" :props="props">{{ formatCurrency(props.row.importe) }}</q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </q-expansion-item>
                    <q-expansion-item header-class="bg-grey-3" class="q-mb-md" switch-toggle-side expand-separator
                        icon="perm_identity" default-opened>
                        <template v-slot:header>
                            <q-item-section>
                                {{ $t('centroCostos.balanceSheet.deferredLiabilities') }}
                            </q-item-section>
                            <q-item-section side>
                                {{ formatCurrency(sumPasivoDiferido) }}
                            </q-item-section>
                        </template>
                        <q-table class="shadow-0" full-width row-key="name" :columns="columns"
                            :data="itemsPasivoDiferido" hide-header hide-bottom :rows-per-page-options="[0]"
                            :pagination.sync="pagination">
                            <template v-slot:body="props">
                                <q-tr :props="props">
                                    <q-td auto-width key="acciones">
                                        <q-btn size="md" color="red-6" rounded flat dense icon="mdi-dots-vertical" v-if="props.row.detalles"
                                            @click="VerDetalles(props.row)">
                                            <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                                content-style="font-size: 14px">{{ $t('centroCostos.balanceSheet.details') }}</q-tooltip>
                                        </q-btn>
                                    </q-td>
                                    <q-td key="descripcion" :props="props">{{ props.row.descripcion }}</q-td>
                                    <q-td key="importe" :props="props">{{ formatCurrency(props.row.importe) }}</q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </q-expansion-item>
                    <q-expansion-item header-class="bg-grey-3" class="q-mb-md" switch-toggle-side expand-separator
                        icon="perm_identity" default-opened>
                        <template v-slot:header>
                            <q-item-section>
                                {{ $t('centroCostos.balanceSheet.equity') }}
                            </q-item-section>
                            <q-item-section side>
                                {{ formatCurrency(sumCapital) }}
                            </q-item-section>
                        </template>
                        <q-table class="shadow-0" full-width row-key="name" :columns="columns" :data="itemsCapital"
                            hide-header hide-bottom :rows-per-page-options="[0]" :pagination.sync="pagination">
                            <template v-slot:body="props">
                                <q-tr :props="props">
                                    <q-td auto-width key="acciones">
                                        <q-btn size="md" color="red-6" rounded flat dense icon="mdi-dots-vertical" v-if="props.row.detalles"
                                            @click="VerDetalles(props.row)">
                                            <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                                content-style="font-size: 14px">{{ $t('centroCostos.balanceSheet.details') }}</q-tooltip>
                                        </q-btn>
                                    </q-td>
                                    <q-td key="descripcion" :props="props">{{ props.row.descripcion }}</q-td>
                                    <q-td key="importe" :props="props">{{ formatCurrency(props.row.importe) }}</q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </q-expansion-item>
                </q-list>
            </div>
        </div>
        <q-footer class="bg-dark" dark elevated style="height: 45px; margin-top: 0px;">
            <q-toolbar>
                <q-space></q-space>
                <div style="font-size: 18px; margin-right: 12px;">{{ $t('reportes.estadoSituacionFinanciera.totalAssetsLabel') || 'Total Activo:' }} </div>
                <div class="text-h6">{{ formatCurrency(sumTotalActivo) }}</div>
                <q-space></q-space>
                <div style="font-size: 18px; margin-right: 12px;">{{ $t('reportes.estadoSituacionFinanciera.totalLiabilitiesCapitalLabel') || 'Total Pasivo + Capital:' }} </div>
                <div class="text-h6">{{ formatCurrency(sumTotalPasivoCapital) }}</div>
                <q-space></q-space>
            </q-toolbar>
        </q-footer>
    </q-page>
</template>
<script>

import { format } from 'date-fns';
import { parse } from 'date-fns';
import { endOfMonth } from 'date-fns';
import { es } from 'date-fns/locale';
import moment from 'moment';
import axios from 'axios'
import { QSpinnerCube } from 'quasar'
import { EstadoSituacionFinancieraPDF } from '../PDF/EstadoSituacionFinancieraPDF.js'
import * as XLSX from 'xlsx';
import visorPdf from '../PDF/VisorPDF.vue';

export default {
    components: {visorPdf},
    data() {
        return {
            fechaI: new Date(),
            fechaF: new Date(),
            itemsActivoCirculante: [],
            itemsActivoFijo: [],
            itemsActivoDiferido: [],
            itemsPasivoCirculante: [],
            itemsPasivoLargoPlazo: [],
            itemsPasivoDiferido: [],
            itemsCapital: [],

            pagination: {
                rowsPerPage: 0
            },

            expansion: true,
            itemsCc: [],
            selectCc: null,

            //DETALLE DE LA POLIZA
            dialogPDF: false,
            dialogDetMov: false,
            dataDetPol: [],
            dialogFacturas: false,
            dataFacturas: [],
            dialogPolizas: false,
            dataPolizas: [],
        }
    },
    computed: {
        token() {
            return this.$store.state.usuario;
        },

        empresa() {
            return this.$store.state.empresaStore;
        },

        fehaIMasked() {
            moment.locale('es-mx');
            return this.fechaI ? moment(this.fechaI).format('DD/MMMM/yyyy') : ''
        },

        fechaFMasked() {
            moment.locale('es-mx');
            return this.fechaF ? moment(this.fechaF).format('DD/MMMM/yyyy') : ''
        },

        columns() {
            return [
                { name: 'descripcion', align: 'center', label: this.$t('centroCostos.incomeStatement.description'), field: 'descripcion', style: 'text-align: left;' },
                { name: 'importe', align: 'center', label: this.$t('centroCostos.incomeStatement.amount'), field: 'importe', style: 'text-align: right;' },
            ];
        },

        columnsDetPol() {
            return [
                { name: 'acciones', align: 'center', label: this.$t('centroCostos.incomeStatement.actions'), field: 'acciones' },
                { name: 'numCuenta', align: 'left', label: this.$t('reportes.libroDiario.accountNo') || 'Cuenta', field: 'numCuenta', style: 'text-align: left;' },
                { name: 'descripcion', align: 'left', label: this.$t('centroCostos.incomeStatement.description'), field: 'descripcion', style: 'text-align: left;' },
                { name: 'importe', align: 'right', label: this.$t('centroCostos.incomeStatement.amount'), field: 'importe', style: 'text-align: right;' },
                { name: 'importeComprobantes', align: 'right', label: 'Importe comprobantes', field: 'importeComprobantes', style: 'text-align: right;' },
            ];
        },

        columnsFacturas() {
            return [
                { name: 'acciones', align: 'center', label: this.$t('centroCostos.incomeStatement.actions'), field: 'acciones' },
                { name: 'serie', align: 'left', label: 'Serie', field: 'serie', style: 'text-align: left;' },
                { name: 'folio', align: 'left', label: 'Folio', field: 'folio', style: 'text-align: left;' },
                { name: 'fecha', align: 'left', label: 'Fecha', field: 'fecha', style: 'text-align: left;' },
                { name: 'rfc', align: 'left', label: 'RFC', field: 'rfc', style: 'text-align: left;' },
                { name: 'nombre', align: 'left', label: 'Nombre', field: 'nombre', style: 'text-align: left;' },
                { name: 'tipoComprobante', align: 'left', label: 'Tipo Comprobante', field: 'tipoComprobante', style: 'text-align: left;' },
                { name: 'subTotal', align: 'right', label: 'SubTotal', field: 'subTotal', style: 'text-align: right;' },
                { name: 'total', align: 'right', label: 'Total', field: 'total', style: 'text-align: right;' },
                { name: 'formaPago', align: 'left', label: 'Forma de Pago', field: 'formaPago', style: 'text-align: left;' },
                { name: 'metodoPago', align: 'left', label: 'Método de Pago', field: 'metodoPago', style: 'text-align: left;' },
                { name: 'folioFiscal', align: 'left', label: 'Folio Fiscal', field: 'folioFiscal', style: 'text-align: left;' },
                { name: 'moneda', align: 'left', label: 'Moneda', field: 'moneda', style: 'text-align: left;' },
                { name: 'usoCfdi', align: 'left', label: 'Uso de Cfdi', field: 'usoCfdi', style: 'text-align: left;' },
                { name: 'fechaPago', align: 'left', label: 'Fecha de Pago', field: 'fechaPago', style: 'text-align: left;' },
            ];
        },

        columnsPolizas() {
            return [
                { name: 'acciones', align: 'center', label: this.$t('centroCostos.incomeStatement.actions'), field: 'acciones' },
                { name: 'tipo', align: 'left', label: this.$t('actions.type') || 'Tipo', field: 'tipo', style: 'text-align: left;' },
                { name: 'numPoliza', align: 'left', label: this.$t('reportes.libroDiario.policyNo') || 'Num. Póliza', field: 'numPoliza', style: 'text-align: left;' },
                { name: 'fecha', align: 'left', label: 'Fecha', field: 'fecha', style: 'text-align: left;' },
                { name: 'importe', align: 'right', label: this.$t('centroCostos.incomeStatement.amount'), field: 'importe', style: 'text-align: right;' },
            ];
        },

        sumActivoCirculante() {
            return this.itemsActivoCirculante.reduce((a, b) => a + b.importe, 0);
        },

        sumActivoFijo() {
            return this.itemsActivoFijo.reduce((a, b) => a + b.importe, 0);
        },

        sumActivoDiferido() {
            return this.itemsActivoDiferido.reduce((a, b) => a + b.importe, 0);
        },

        sumPasivoCirculante() {
            return this.itemsPasivoCirculante.reduce((a, b) => a + b.importe, 0);
        },

        sumPasivoLargoPlazo() {
            return this.itemsPasivoLargoPlazo.reduce((a, b) => a + b.importe, 0);
        },

        sumPasivoDiferido() {
            return this.itemsPasivoDiferido.reduce((a, b) => a + b.importe, 0);
        },

        sumCapital() {
            return this.itemsCapital.reduce((a, b) => a + b.importe, 0);
        },

        sumTotalActivo() {
            let a = this.itemsActivoCirculante.reduce((a, b) => a + b.importe, 0);
            let b = this.itemsActivoFijo.reduce((a, b) => a + b.importe, 0);
            let c = this.itemsActivoDiferido.reduce((a, b) => a + b.importe, 0);

            return a + b + c;
        },

        sumTotalPasivoCapital() {
            let a = this.itemsPasivoCirculante.reduce((a, b) => a + b.importe, 0);
            let b = this.itemsPasivoLargoPlazo.reduce((a, b) => a + b.importe, 0);
            let c = this.itemsPasivoDiferido.reduce((a, b) => a + b.importe, 0);
            let d = this.itemsCapital.reduce((a, b) => a + b.importe, 0);
            return a + b + c + d;
        },

    },
    created() {
        this.getCc()

    },
    methods: {
        FormatDate(value) {
            let fecha_a = value.replace('T', ' ');
            let fecha_b = fecha_a.replace('Z', '');
            const cadenaFechaConHora = fecha_b;
            const fecha = parse(cadenaFechaConHora, 'yyyy-MM-dd HH:mm:ss', new Date());
            const formato = "dd-MMMM-yyyy HH:mm:ss";
            const configuracionLocal = { locale: es };
            let resultado = format(fecha, formato, configuracionLocal);
            return resultado;
        },

        UltimoDiaMes() {
            let fechaI = this.fechaI;
            fechaI = fechaI.replaceAll('/', '-');
            const fecha = parse(fechaI, 'yyyy-MM-dd', new Date());
            const ultimoDiaDelMes = endOfMonth(fecha);
            this.fechaF = ultimoDiaDelMes;
        },

        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },

        async GetEstadoDeSituacionFinanciera() {
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'purple', spinnerSize: 140, message: this.$t('centroCostos.list.wait') || 'Generando Estado de Situación Financiera...', messageColor: 'white' });
            try {
                this.itemsActivoCirculante = [];
                this.itemsActivoFijo = [];
                this.itemsActivoDiferido = [];
                this.itemsPasivoCirculante = [];
                this.itemsPasivoLargoPlazo = [];
                this.itemsPasivoDiferido = [];
                this.itemsCapital = [];
                let fechaI = new Date(this.fechaI);
                let fechaF = new Date(this.fechaF);
                fechaI = format(fechaI, 'yyyy-MM-dd');
                fechaF = format(fechaF, 'yyyy-MM-dd');
                let response = await axios.get('CentrosCostos/GetEstadoDeSituacionFinancieraAsync/erp_' + this.token.rfc + '/' + fechaI + '/' + fechaF + '/' + this.selectCc._id);
                console.log(response.data);
                let respuesta = response.data;

                //CREAMOS EL REPORTE (La lógica de filtrado se mantiene igual porque viene de la BD)
                this.itemsActivoCirculante = respuesta.filter(x => x.subTipo === 'ACTIVO CIRCULANTE')
                this.itemsActivoFijo = respuesta.filter(x => x.subTipo === 'ACTIVO FIJO')
                this.itemsActivoDiferido = respuesta.filter(x => x.subTipo === 'ACTIVO DIFERIDO')
                this.itemsPasivoCirculante = respuesta.filter(x => x.subTipo === 'PASIVO CIRCULANTE')
                this.itemsPasivoLargoPlazo = respuesta.filter(x => x.subTipo === 'PASIVO A LARGO PLAZO')
                this.itemsPasivoDiferido = respuesta.filter(x => x.subTipo === 'PASIVO DIFERIDO')
                this.itemsCapital = respuesta.filter(x => x.subTipo === 'CAPITAL')
                this.$q.loading.hide()
            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
            }
        },

        async ExportarPdf() {
            let activoCirculante = [...this.itemsActivoCirculante];
            let activoFijo = [...this.itemsActivoFijo];
            let activoDiferido = [...this.itemsActivoDiferido];
            let pasivoCirculante = [...this.itemsPasivoCirculante];
            let pasivoLargoPlazo = [...this.itemsPasivoLargoPlazo];
            let pasivoDiferido = [...this.itemsPasivoDiferido];
            let capital = [...this.itemsCapital];

            let fechaI = new Date(this.fechaI);
            let fechaF = new Date(this.fechaF);
            const pdfBase64 = await EstadoSituacionFinancieraPDF(activoCirculante, activoFijo, activoDiferido, pasivoCirculante, pasivoLargoPlazo, pasivoDiferido, capital, this.empresa, fechaI, fechaF);
            const fileName = 'Estado_de_Situación_Financiera_del_' + this.FormatoFechaSinHora(fechaI) + '_al_' + this.FormatoFechaSinHora(fechaF) + ".pdf";
            const link = document.createElement("a");
            link.href = pdfBase64;
            link.download = fileName;
            link.click();
        },

        async ExportExcel() {
            let fechaI = new Date(this.fechaI);
            let fechaF = new Date(this.fechaF);

            const columnsToInclude = ['descripcion', 'importe'];
            const dataActivoCirculante = [...this.itemsActivoCirculante];
            const dataActivoFijo = [...this.itemsActivoFijo];
            const dataActivoDiferido = [...this.itemsActivoDiferido];
            const dataPasivoCirculante = [...this.itemsPasivoCirculante]
            const dataPasivoLargoPlazo = [...this.itemsPasivoLargoPlazo]
            const dataPasivoDiferido = [...this.itemsPasivoDiferido]
            const dataCapital = [...this.itemsCapital]

            //EXTRAEMOS LOS DATOS QUE NECESITAMOS
            const datosActivoCirculante = dataActivoCirculante.map(item =>
                columnsToInclude.reduce((acc, column) => {
                    acc[column] = item[column];
                    return acc;
                }, {})
            );
            const datosActivoFijo = dataActivoFijo.map(item =>
                columnsToInclude.reduce((acc, column) => {
                    acc[column] = item[column];
                    return acc;
                }, {})
            );
            const datosActivoDiferido = dataActivoDiferido.map(item =>
                columnsToInclude.reduce((acc, column) => {
                    acc[column] = item[column];
                    return acc;
                }, {})
            );
            const datosPasivoCirculante = dataPasivoCirculante.map(item =>
                columnsToInclude.reduce((acc, column) => {
                    acc[column] = item[column];
                    return acc;
                }, {})
            );
            const datosPasivoLargoPlazo = dataPasivoLargoPlazo.map(item =>
                columnsToInclude.reduce((acc, column) => {
                    acc[column] = item[column];
                    return acc;
                }, {})
            );
            const datosPasivoDiferido = dataPasivoDiferido.map(item =>
                columnsToInclude.reduce((acc, column) => {
                    acc[column] = item[column];
                    return acc;
                }, {})
            );
            const datosCapital = dataCapital.map(item =>
                columnsToInclude.reduce((acc, column) => {
                    acc[column] = item[column];
                    return acc;
                }, {})
            );

            //CREAMOS LOS ARRAY DE VALORES, SIN OBJETOS
            const arrayActivoCirculante = datosActivoCirculante.map(objeto => Object.values(objeto));
            const arrayActivoFijo = datosActivoFijo.map(objeto => Object.values(objeto));
            const arrayActivoDiferido = datosActivoDiferido.map(objeto => Object.values(objeto));
            const arrayPasivoCirculante = datosPasivoCirculante.map(objeto => Object.values(objeto));
            const arrayPasivoLargoPlazo = datosPasivoLargoPlazo.map(objeto => Object.values(objeto));
            const arrayPasivoDiferido = datosPasivoDiferido.map(objeto => Object.values(objeto));
            const arrayCapital = datosCapital.map(objeto => Object.values(objeto));

            // VALORES DE LAS SUMATORIAS
            const sumaActivo = this.sumActivoCirculante + this.sumActivoFijo + this.sumActivoDiferido;
            const sumaActivoYCapital = this.sumPasivoCirculante + this.sumPasivoLargoPlazo + this.sumPasivoDiferido + this.sumCapital;

            const libroTrabajo = XLSX.utils.book_new();

            //CREAMOS LA HOJA CON TODO EL CONTENIDO
            const hojaCalculo = XLSX.utils.aoa_to_sheet([
                [this.$t('reportes.estadoSituacionFinanciera.title').toUpperCase()],
                [this.empresa.rfc + '| ' + this.empresa.nombre],
                ['DEL ' + this.FormatoFechaSinHora(fechaI) + ' AL ' + this.FormatoFechaSinHora(fechaF)],
                [],
                [this.$t('reportes.estadoSituacionFinancieraAnual.reportTitle').toUpperCase()],
                [this.$t('centroCostos.balanceSheet.currentAssets').toUpperCase(), { t: 'n', v: this.sumActivoCirculante, z: '#,##0.00' }],
                ...arrayActivoCirculante.map((registro, index) => [
                    registro[0],
                    { t: 'n', v: registro[1], z: '#,##0.00' },
                ]),
                [],
                [this.$t('centroCostos.balanceSheet.fixedAssets').toUpperCase(), { t: 'n', v: this.sumActivoFijo, z: '#,##0.00' }],
                ...arrayActivoFijo.map((registro, index) => [
                    registro[0],
                    { t: 'n', v: registro[1], z: '#,##0.00' },
                ]),
                [],
                [this.$t('centroCostos.balanceSheet.deferredAssets').toUpperCase(), { t: 'n', v: this.sumActivoDiferido, z: '#,##0.00' }],
                ...arrayActivoDiferido.map((registro, index) => [
                    registro[0],
                    { t: 'n', v: registro[1], z: '#,##0.00' },
                ]),
                [],
                [this.$t('reportes.estadoSituacionFinanciera.totalAssets').toUpperCase(), { t: 'n', v: sumaActivo, z: '#,##0.00' }],
                ['--------------------', '--------------------'],
                ['PASIVO'],
                [this.$t('centroCostos.balanceSheet.currentLiabilities').toUpperCase(), { t: 'n', v: this.sumPasivoCirculante, z: '#,##0.00' }],
                ...arrayPasivoCirculante.map((registro, index) => [
                    registro[0],
                    { t: 'n', v: registro[1], z: '#,##0.00' },
                ]),
                [],
                [this.$t('centroCostos.balanceSheet.longTermLiabilities').toUpperCase(), { t: 'n', v: this.sumPasivoLargoPlazo, z: '#,##0.00' }],
                ...arrayPasivoLargoPlazo.map((registro, index) => [
                    registro[0],
                    { t: 'n', v: registro[1], z: '#,##0.00' },
                ]),
                [],
                [this.$t('centroCostos.balanceSheet.deferredLiabilities').toUpperCase(), { t: 'n', v: this.sumPasivoDiferido, z: '#,##0.00' }],
                ...arrayPasivoDiferido.map((registro, index) => [
                    registro[0],
                    { t: 'n', v: registro[1], z: '#,##0.00' },
                ]),
                [],
                [this.$t('centroCostos.balanceSheet.equity').toUpperCase(), { t: 'n', v: this.sumCapital, z: '#,##0.00' }],
                ...arrayCapital.map((registro, index) => [
                    registro[0],
                    { t: 'n', v: registro[1], z: '#,##0.00' },
                ]),
                [],
                [this.$t('reportes.estadoSituacionFinanciera.totalLiabilitiesCapital').toUpperCase(), { t: 'n', v: sumaActivoYCapital, z: '#,##0.00' }],
                ['--------------------', '--------------------'],
            ]);

            // Combinar celdas A1 a H1 y centrar texto
            hojaCalculo['!merges'] = [{ s: { r: 0, c: 0 }, e: { c: 3, r: 0 } }];
            hojaCalculo['!merges'].push({ s: { c: 0, r: 1 }, e: { c: 3, r: 1 } });
            hojaCalculo['!merges'].push({ s: { c: 0, r: 2 }, e: { c: 3, r: 2 } });

            // Añadir la hoja de cálculo al libro de trabajo
            XLSX.utils.book_append_sheet(libroTrabajo, hojaCalculo, 'Hoja1');

            // Guardar el libro como un archivo XLSX
            const nombreArchivo = 'ESTADO DE SITUACIÓN FINANCIERA ' + this.empresa.rfc + '_' + this.empresa.nombre + ' DEL ' + this.FormatoFechaSinHora(fechaI) + ' AL ' + this.FormatoFechaSinHora(fechaF)
            XLSX.writeFile(libroTrabajo, nombreArchivo + '.xlsx');
        },

        FormatoFechaSinHora(value) {
            const fecha = new Date(value);
            const fechaFormateada = format(fecha, 'dd-MMMM-yyyy', { locale: es });
            return fechaFormateada.toUpperCase();
        },

        async getCc(){
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'purple', spinnerSize: 140, message: this.$t('centroCostos.list.wait') || 'Espere...', messageColor: 'white' })
            try {
                const response = await axios.get('CentrosCostos/GetCentroCostosAsync/erp_' + this.token.rfc)
                this.itemsCc = response.data;
                this.$q.loading.hide();
                console.log(response.data)
                this.dialogAsignaCc = true
            } catch (error) {
                console.log(error)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', message: this.$t('centroCostos.list.errorFetch') || 'Error al consultar.', color: 'red' })
            }
        },

        async VerDetalles(item){
            this.$q.loading.show({ spinner: QSpinnerCube, spinnerColor: 'purple', spinnerSize: 140, message: this.$t('centroCostos.list.wait') || 'Espere...', messageColor: 'white' })
            let detalle = [];
            for(let i of item.detalles){
                const objPol = {
                    idPoliza : null,
                    numCuenta: i.numCuentaSat
                };
                detalle.push(objPol)
            }

            const model = {
                lista: detalle,
            }

            const respuesta = await this.GetDetalle(model);
            this.dataDetPol = [...respuesta]
            this.dialogDetMov =  true;
            this.$q.loading.hide()
        },

        async GetDetalle(model){
            try{
                let fechaI = new Date(this.fechaI);
                let fechaF = new Date(this.fechaF);
                fechaI = format(fechaI, 'yyyy-MM-dd');
                fechaF = format(fechaF, 'yyyy-MM-dd');
                const response = await axios.post(`CentrosCostos/GetDetallePolizasAsync/erp_${this.token.rfc}/${fechaI}/${fechaF}/${this.selectCc._id}`, model)
                return response.data;
            }catch(error){
                console.log(error);
                return null;
            }
        },

        async VerPolizas(item){
            console.log(item);
            this.dataPolizas = [];
            this.dataPolizas = item.polizas;
            this.dialogPolizas = true;
        },

        async VerPolizaPdf(item){
            console.log(item)
            const id = item._id;
            const poliza = await this.GetPolizaId(id)
            this.dialogPDF = true;
            this.$nextTick(() => {
                this.$store.state.vistaPreviaStore.color = "19775C"
                this.$store.state.vistaPreviaStore.tipo = "POLIZA"
                this.$refs.miComponenteHijo.VerPolizaPdf(poliza);
            }
            );
        },

        async VerFacturas(item){
            console.log(item);
            this.dataFacturas = [];
            this.dataFacturas = item.facturas;
            this.dialogFacturas = true;
        },

        async VerFacturaPdf(item){
            console.log(item)
            let tipo = item.tipoPoliza 
            if (tipo === 'Egreso') {
                this.$store.state.vistaPreviaStore.tipo = "R"
                this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "FACTURA"
                if (item.tipoComprobante === "N") {
                    this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "NOMINA"
                    this.$store.state.vistaPreviaStore.tipo = "E"
                } else if (item.tipoComprobante === "P") {
                    this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "PAGO"
                } else if (item.tipoComprobante === "E") {
                    this.$store.state.vistaPreviaStore.tipo = "E"
                }

            } else if (tipo === 'Ingreso') {
                this.$store.state.vistaPreviaStore.tipo = "E"
                this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "FACTURA"
                if (item.tipoComprobante === "N") {
                    this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "NOMINA"
                    this.$store.state.vistaPreviaStore.tipo = "R"
                } else if (item.tipoComprobante === "P") {
                    this.$store.state.vistaPreviaStore.tipoComprobanteInterno = "PAGO"
                } else if (item.tipoComprobante === "E") {
                    this.$store.state.vistaPreviaStore.tipo = "R"
                }
            }
            try {
                this.dialogPDF = true;
                this.$nextTick(() => {
                    this.$store.state.vistaPreviaStore.folioFiscal = item.folioFiscal.toUpperCase();
                    this.$store.state.vistaPreviaStore.color = "19775C"
                    this.$store.state.vistaPreviaStore.rfc = this.token.rfc
                    this.$refs.miComponenteHijo.VerComprobante();
                });
            } catch (error) {
                console.log(error)
            }
        },

        async GetPolizaId(id) {
            try {
                let response = await axios.get("Polizas/GetPolizasIdAsync/erp_" + this.token.rfc + '/' + id);
                let poliza = response.data;
                return poliza
            } catch (error) {
                console.log(error)
            }
        },

        CloseDialogPdf() {
            this.dialogPDF = false;
        },
    }
}
</script>

<style>
.header-tabla thead th {
    border-bottom: 8px solid #662e91;
}
</style>